import {styled} from "@reside/ui";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  text-align: left;
  padding: 10px 12px;
  border-bottom: 2px solid #ebedf0;
  color: #596973;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
`;

export const Td = styled.td`
  padding: 10px 12px;
  border-bottom: 1px solid #ebedf0;
  color: #203c63;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #203c63;
  margin: 0 0 12px;
`;
